/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Goal_StrengthInputs */

const en_us2_onboarding_goal_strength = /** @type {(inputs: Onboarding_Goal_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get stronger`)
};

const pt_br2_onboarding_goal_strength = /** @type {(inputs: Onboarding_Goal_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ficar mais forte`)
};

const es_419_onboarding_goal_strength = /** @type {(inputs: Onboarding_Goal_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ser más fuerte`)
};

const pt_pt2_onboarding_goal_strength = /** @type {(inputs: Onboarding_Goal_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ficar mais forte`)
};

const fr_fr2_onboarding_goal_strength = /** @type {(inputs: Onboarding_Goal_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagner en force`)
};

const de_de2_onboarding_goal_strength = /** @type {(inputs: Onboarding_Goal_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stärker werden`)
};

const it_it2_onboarding_goal_strength = /** @type {(inputs: Onboarding_Goal_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diventare più forte`)
};

/**
* | output |
* | --- |
* | "Get stronger" |
*
* @param {Onboarding_Goal_StrengthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_goal_strength = /** @type {((inputs?: Onboarding_Goal_StrengthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Goal_StrengthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_goal_strength(inputs)
	if (locale === "es-419") return es_419_onboarding_goal_strength(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_goal_strength(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_goal_strength(inputs)
	if (locale === "de-DE") return de_de2_onboarding_goal_strength(inputs)
	if (locale === "it-IT") return it_it2_onboarding_goal_strength(inputs)
	return en_us2_onboarding_goal_strength(inputs)
});
export { onboarding_goal_strength as "onboarding.goal.strength" }